import { loadScript } from './loadScript.js'
import { getPlatform } from './getPlatform'

function askSubmitVerify(el = '#sc') {
  let smartCaptcha = window.smartCaptcha,
    NVC_Opt = window.NVC_Opt

  return new Promise(resolve => {
    if (window.NVC_Opt && smartCaptcha) {
      var ic = new smartCaptcha({
        renderTo: el,
        width: '100%',
        secvrf_layout: true,
        height: 42,
        default_txt: '点击按钮开始智能验证',
        success_txt: '验证成功',
        fail_txt: '验证失败，请在此点击按钮刷新',
        scaning_txt: '智能检测中',
        success: function(data) {
          console.log(NVC_Opt.token)
          console.log(data.sessionId)
          console.log(data.sig)
          resolve({
            token: NVC_Opt.token,
            sessionId: data.sessionId,
            sig: data.sig
          })
        }
      })
      ic.init()
    } else {
      resolve(null)
    }
  })
}

function consultAliVerify(config = {}) {
  return new Promise(resolve => {
    const platform = getPlatform()
    let today = new Date()
    const timeStamp = `${today.getFullYear()}${today.getMonth() +
      1}${today.getDay()}`
    const nc_appKey = 'FFFF000000000182B110'
    const nc_token = [nc_appKey, new Date().getTime(), Math.random()].join(':')

    const loadUrl = platform.isPc
      ? `//g.alicdn.com/sd/ncpc/nc.js`
      : `//g.alicdn.com/sd/nch5/index.js`
    let nc_sence = platform.isPc ? 'nc_register' : 'nc_message_h5'

    let slid_nc_opt = platform.isPc
      ? {
          renderTo: '#nc',
          appkey: nc_appKey,
          scene: nc_sence,
          token: nc_token,
          customWidth: '100%',
          trans: { key1: 'code0' },
          is_Opt: 0,
          language: 'cn',
          isEnabled: true,
          timeout: 3000,
          times: 5,
          apimap: {},
          callback: data => resolve({ ...data, nc_sence, nc_token, nc_appKey })
        }
      : {
          renderTo: '#nc',
          appkey: nc_appKey,
          scene: nc_sence,
          token: nc_token,
          trans: { key1: 'code0' },
          elementID: ['usernameID'],
          is_Opt: 0,
          language: 'cn',
          timeout: 10000,
          retryTimes: 5,
          errorTimes: 5,
          inline: false,
          apimap: {
            // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
            // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
          },
          bannerHidden: false,
          initHidden: false,
          callback: data => resolve({ ...data, nc_sence, nc_token, nc_appKey })
        }

    Object.assign(slid_nc_opt, config)

    loadScript(`${loadUrl}?t=${timeStamp}`).then(() => {
      const noCaptcha = window.noCaptcha
      if (platform.isPc) {
        let slid_nc = new noCaptcha(slid_nc_opt)
        slid_nc.upLang('cn', {
          _startTEXT: '请按住滑块，拖动到最右边',
          _yesTEXT: '验证通过',
          _error300:
            '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
          _errorNetwork:
            '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
        })
      } else {
        let nc = window.NoCaptcha.init(slid_nc_opt)
        window.NoCaptcha.setEnabled(true)
        nc.reset() //请务必确保这里调用一次reset()方法
        window.NoCaptcha.upLang('cn', {
          LOADING: '加载中...', //加载
          SLIDER_LABEL: '请向右滑动验证', //等待滑动
          CHECK_Y: '验证通过', //通过
          ERROR_TITLE: '非常抱歉，这出错了...', //拦截
          CHECK_N: '验证未通过', //准备唤醒二次验证
          OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码', //二次验证
          TIPS_TITLE: '验证码错误，请重新输入' //验证码输错时的提示
        })
      }
    })
  })
}

function consultAliVerifyV2(config = {}) {
  return new Promise((resolve, reject) => {
    let today = new Date()
    const timeStamp = `${today.getFullYear()}${
      today.getMonth() + 1
    }${today.getDay()}`
    const loadUrl = `//o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js`
    window.AliyunCaptchaConfig = {
      // 必填，验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
      region: 'cn',
      // 必填，身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      prefix: '1kq7dm'
    }
    let instance
    return loadScript(`${loadUrl}?t=${timeStamp}`).then(() => {
      // 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        SceneId: 'igx61m86',
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: 'embed',
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: '#nc',
        // 触发验证码弹窗或无痕验证的元素
        button: '#nc-verify-btn',
        timeout: 10000,
        // 验证码验证通过回调函数
        success: function (captchaVerifyParam) {
          // 入参为验签captchaVerifyParam
          // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
          // 2.根据校验结果来进行业务处理
          // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
          resolve(captchaVerifyParam)
        },
        // 验证码验证不通过回调函数
        fail: function (result) {
          // 入参为不通过信息
          // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
          console.error(result)
          reject(result)
        },
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: function (instance) {
          instance = instance
        },
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
        slideStyle: {
          width: 320, //最小宽度320px
          height: 40
        },
        language: 'cn', // 验证码语言类型 比如 "cn"。
        upLang: {
          cn: {
            // 不同验证形态下的交互提示文案。
            SLIDE_TIP: '请向右滑动验证',
            // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
            VERIFYING: '验证中...',
            // 验证通过的提示文案，所有验证形态通用。
            SUCCESS: '验证通过',
            // 验证失败的提示文案，滑块验证和一点即过形态下适用。
            SLIDE_FAIL: '验证失败，请刷新重试',
            // 网络情况异常的提示文案。
            CONGESTION: '网络异常，请刷新重试'
          }
        },
        // ...其他参数，参考initAliyunCaptcha参数说明: https://help.aliyun.com/zh/captcha/captcha2-0/user-guide/new-architecture-for-web-and-h5-client-access?spm=a2c4g.11186623.help-menu-28308.d_2_4_0.416acc9bkHlL0c
        ...config
      })
    })
  })
}

export default {
  askSubmitVerify,
  consultAliVerify,
  consultAliVerifyV2
}

export { askSubmitVerify, consultAliVerify, consultAliVerifyV2 }



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/aliVerify.js